
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/lemonade-goes-global",
      function () {
        return require("private-next-pages/fr/en/lemonade-goes-global.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/lemonade-goes-global"])
      });
    }
  